import {
    GET_COST_CENTER_BY_MARKET,
    SET_COST_CENTER_BY_MARKET
} from "./CostCenterByMarketType"

const getCostCenterByMarket = (payload?: any, isHierarchy:any = false) => ({
    type: GET_COST_CENTER_BY_MARKET,
    payload,
    isHierarchy
});

const setCostCenterByMarket = (costCenterByMarket: any) => ({
    type: SET_COST_CENTER_BY_MARKET,
    costCenterByMarket: costCenterByMarket
});

export {
    getCostCenterByMarket,
    setCostCenterByMarket
}
